export default __webpack_public_path__ + "_/images/app/android/android-en-4-3e2b46809989e9cc54c4aebf238932ce770dc3ecfe531873cdd7db374143218a.png";